import { render, staticRenderFns } from "./CoUserBookings.vue?vue&type=template&id=583847e6&"
import script from "./CoUserBookings.vue?vue&type=script&lang=ts&"
export * from "./CoUserBookings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports